import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import CopyToClipboard from './CopyToClipboard';

function CopyUrlSection(): React.JSX.Element {
    return (
        <div className="flex flex-col gap-3">
            <p className="text-muted-foreground text-sm md:text-base">
                {`${UIStrings.BookmarkingThisPageUseThisUrl}: `}
            </p>
            <CopyToClipboard />
        </div>
    );
}

export default CopyUrlSection;
